'use client';

import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import {
  getUserPreferencesService,
} from '@/services/httpServices/PreferenceServices';
import type {
  GetUserPreferencesServiceConfig,
  UserPreferencesResponse,
} from '@/services/httpServices/PreferenceServices/types';

import { userPreferencesKeys } from './preferenceQueryKeys';
import { useQueryConfig } from './useQueryConfig';

export function useUserPreferencesQuery(
  config: GetUserPreferencesServiceConfig,
  options?: Omit<UseQueryOptions<UserPreferencesResponse>, 'queryKey' | 'queryFn'>,
) {
  const { isEnabled } = useQueryConfig();

  return useQuery<UserPreferencesResponse>({
    queryKey: userPreferencesKeys(config),
    queryFn: async () => {
      if (config.params?.id === undefined) {
        throw new Error('User ID is required');
      }
      return getUserPreferencesService(config);
    },
    enabled: isEnabled && config.params?.id !== undefined && config.params?.id !== null && config.params.id !== '',
    ...options,
  });
}
